import * as yup from "yup";

export const createValidationSchema = yup.object().shape({
  code: yup.string().min(2, "Mã tài khoản phải có ít nhất 2 ký tự"),
  bankName: yup.string().required("Vui lòng nhập tên ngân hàng"),
  accountNumber: yup.string().required("Vui lòng nhập số tài khoản"),
  accountHolder: yup.string().required("Vui lòng nhập tên chủ tài khoản"),
});
